export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 64

export const PASSWORD_HINT =
  '密码至少8位，须同时包含大写字母、小写字母、数字和特殊字符'

/** @returns {{ ok: boolean, message: string }} */
export function validatePassword(password) {
  if (typeof password !== 'string') {
    return { ok: false, message: PASSWORD_HINT }
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return { ok: false, message: PASSWORD_HINT }
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return { ok: false, message: '密码长度不能超过64位' }
  }

  let hasUpper = false
  let hasLower = false
  let hasDigit = false
  let hasSpecial = false

  for (const ch of password) {
    if (ch >= 'A' && ch <= 'Z') hasUpper = true
    else if (ch >= 'a' && ch <= 'z') hasLower = true
    else if (ch >= '0' && ch <= '9') hasDigit = true
    else hasSpecial = true
  }

  if (!hasUpper || !hasLower || !hasDigit || !hasSpecial) {
    return { ok: false, message: PASSWORD_HINT }
  }
  return { ok: true, message: '' }
}

export function passwordsMatch(password, confirmPassword) {
  return password === confirmPassword
}
